// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P9Uwu","input":"styles_input__1xq8d"};